const PROVIDER_IMAGE_BASE_URL = "https://space.pgzone88.com";

const getProviderId = (provider) => {
  const value =
    provider?.id || provider?.productId || provider?.game || provider?.provider;

  return String(value || "").trim();
};

const getProviderCategoryCode = (provider, categoryCode) => {
  return String(categoryCode || provider?.categoryCode || provider?.type || "")
    .trim()
    .toUpperCase();
};

export const buildProviderImageUrl = (provider, categoryCode) => {
  const providerId = getProviderId(provider);

  if (!providerId) {
    return "";
  }

  const resolvedCategoryCode = getProviderCategoryCode(provider, categoryCode);
  const extension = resolvedCategoryCode === "SPORTS" ? "gif" : "webp";

  return `${PROVIDER_IMAGE_BASE_URL}/${providerId}.${extension}`;
};

export const resolveProviderImage = (provider, fallback = "") => {
  const providerImageUrl = buildProviderImageUrl(provider);

  if (providerImageUrl) {
    return providerImageUrl;
  }

  const image = provider?.image || provider?.logo || provider?.img || "";

  if (image) {
    return image;
  }

  return fallback;
};
